var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 7.8001C8.95488 7.8001 9.87055 7.42081 10.5457 6.74568C11.2208 6.07055 11.6001 5.15488 11.6001 4.2001C11.6001 3.24532 11.2208 2.32964 10.5457 1.65451C9.87055 0.979382 8.95488 0.600098 8.0001 0.600098C7.04532 0.600098 6.12964 0.979382 5.45451 1.65451C4.77938 2.32964 4.4001 3.24532 4.4001 4.2001C4.4001 5.15488 4.77938 6.07055 5.45451 6.74568C6.12964 7.42081 7.04532 7.8001 8.0001 7.8001ZM2.89875 18.6001C1.07696 18.6001 -0.457661 17.0687 0.23951 15.3856C0.661649 14.3664 1.28039 13.4404 2.0604 12.6604C2.84041 11.8804 3.76642 11.2616 4.78556 10.8395C5.80469 10.4174 6.89699 10.2001 8.0001 10.2001C9.1032 10.2001 10.1955 10.4174 11.2146 10.8395C12.2338 11.2616 13.1598 11.8804 13.9398 12.6604C14.7198 13.4404 15.3385 14.3664 15.7607 15.3856C16.4579 17.0687 14.9232 18.6001 13.1014 18.6001H2.89875Z",
    fill: "#6A4029"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.63caed2e3512611c4ffd2cff0025cdec.svg";
export { ForwardRef as ReactComponent };